<mat-form-field appearance="fill" style="margin-top: -23px;">
    <span matSuffix *ngIf="dobValue.value" (click)="clearText()"><i  class="fas fa-times"></i></span>       
        <input class="custom-componentFont" [formControl]="dobControl" #dobValue (keypress)="validateDOB($event)" (input)="updateDOB($event)"
          maxlength="10" matInput>
</mat-form-field>